<template lang="pug">
v-container.pa-8(fluid)
  .d-flex.align-center.mb-4
    v-btn.mr-4(icon small)
      v-icon(color="primary" @click="onClickBack") mdi-arrow-left
    .text-2xl.font-semibold {{ $t('templates') }}
  v-row.pb-2.pb-md-0(no-gutters)
    v-col(cols="12" md="8")
      v-tabs(v-model="templateTab" color="basic700" :height="44" :grow="isMobileScreen")
        v-tab.text-sm.font-semibold.text-none.px-4 {{ $t('all') }}
        v-tab.text-sm.font-semibold.text-none.px-4 {{ $t('medical_certificate') }}
        v-tab.text-sm.font-semibold.text-none.px-4 Prescription letter
        v-tab.text-sm.font-semibold.text-none.px-4 {{ $t('medical_records') }}
        v-tab.text-sm.font-semibold.text-none.px-4 {{ $t('billings') }}
    v-col(cols="12" md="4" align="end")
      .d-flex.align-center
        v-spacer
        v-btn(@click="clickSearch" icon color="neutral500")
          v-icon(size="20") $yzi-search-sm
        v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
        v-btn.button-sm.ml-4(color="neutral700" dark depressed @click="onAddDocument") {{ $t('add_item', { item: $t('template').toLowerCase() }) }}
  v-divider
  filter-row.my-2(:filters.sync="filters" ref="filter")
  .data-table
    v-data-table.mt-sm-4.pb-6(:headers="headers" :items="documents" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetching" disable-sort @click:row="" loader-height="2")
      //- Description
      template(v-slot:item.description="{ item }")
        v-tooltip(v-if="item.description" top color="neutral700")
          template(#activator="{ on, attrs }")
            div(v-bind="attrs" v-on="on" style="max-width: 175px;")
              .text-sm.neutral700--text.cursor-help.truncate {{ item.description }}
          div(style="max-width: 500px;")
            .text-sm {{ item.description }}
      //- Category
      template(v-slot:item.category="{ item }")
        .text-sm {{ getCategory(item.category) }}
      //- Price range
      template(v-slot:item.price="{ item }")
        template(v-if="isMedicalDocumentCategory(item.category)")
          .text-sm.success500--text {{ item.price_range[0] | displayPrice($currency) }}
            span.text-sm.success500--text(v-if="item.price_range.length > 1") &nbsp; - {{ item.price_range[1] | displayPrice($currency) }}
      //- Status
      template(v-slot:item.status="{ item }")
        y-switch.mb-n3.mx-0.pa-0(v-model="item.status" @change="updateStatus(item, item.status)")
      //- Action
      template(v-slot:item.action="{ item }")
        div.py-3
          v-menu(offset-y left attach rounded="lg")
            template(#activator="{ on }")
              v-btn.ml-4(icon small v-on="on")
                v-icon mdi-dots-horizontal
            v-list.py-0
              template(v-for="(action, actionIdx) in actions")
                v-divider(v-if="actionIdx !== 0")
                v-list-item(:key="'action-' + actionIdx" @click="onClickAction(item, action)")
                  v-list-item-title.text-sm.basic800--text(:class="[action.textColor]") {{ action.text }}
  div.d-flex.align-center(v-if="totalCount > pageSize")
    v-spacer
    div
      yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" text="Item list" attach menu-top @input="pageChanged")
  .dialogs
    delete-document-template-dialog(v-if="openConfirmDeleteTemplateDialog" :open.sync="openConfirmDeleteTemplateDialog" :loading="isDeleting" @delete="onDelete")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'
import FilterRow from '@/components/clinic/manage/document/FilterRow.vue'
import DeleteDocumentTemplateDialog from '@/components/clinic/dialogs/DeleteDocumentTemplateDialog.vue'

export default {
  components: {
    FilterRow, DeleteDocumentTemplateDialog
  },
  data() {
    return {
      templateTab: 0,
      searchText: null,
      showSearchField: false,
      pageSize: 20,
      currentPage: 1,
      totalCount: 0,
      isFetching: false,
      openConfirmDeleteTemplateDialog: false,
      filters: [],
      documents: [],
      selectedDocument: null,
      isDeleting: false,
      headers: [
        {
          id: 'NAME',
          text: 'NAME',
          value: 'name'
        },
        {
          id: 'DESCRIPTION',
          text: 'DESCRIPTION',
          value: 'description'
        },
        {
          id: 'CATEGORY',
          text: 'CATEGORY',
          value: 'category'
        },
        {
          id: 'PRICE TO PATIENT',
          text: 'PRICE TO PATIENT',
          value: 'price'
        },
        {
          id: 'STATUS',
          text: 'STATUS',
          value: 'status'
        },
        {
          id: 'ACTION',
          text: 'ACTION',
          value: 'action'
        }
      ],
      actions: [
        {
          text: this.$t('edit_template'),
          textColor: 'neutral700--text'
        },
        {
          text: this.$t('delete_template'),
          textColor: 'danger500--text'
        }
      ]
    }
  },
  mounted () {
    this.fetchDocumentTemplates()
  },
  watch: {
    filters () {
      this.currentPage = 1
      this.fetchDocumentTemplates()
    },
    templateTab () {
      this.fetchDocumentTemplates()
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    params () {
      let params = {
        categories: this.getTabCategory(),
        search: this.searchText || null,
        page_size: this.pageSize,
        page: this.currentPage,
        company: this.company.id
      }
      this.filters.forEach(filter => {
        params[filter.key] = filter.value
      })
      return params
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    queryChanged : debounce(function () {
      this.fetchDocumentTemplates()
    }, 750),
    onClickBack () {
      this.$router.push('/admin/clinic/settings')
    },
    pageChanged(num) {
      this.page = num
      this.fetchDocumentTemplates()
    },
    onAddDocument () {
      this.$router.push('/admin/clinic/settings/document/template')
    },
    onEditDocument (id) {
      this.$router.push(`/admin/clinic/settings/document/template/${id}`)
    },
    onClickAction (item, action) {
      switch (action.text) {
        case this.$t('edit_template'):
          this.onEditDocument(item.id)
          return

        case this.$t('delete_template'):
          this.selectedDocument = item
          this.openConfirmDeleteTemplateDialog = true
          return
      
        default:
          return
      }
    },
    async fetchDocumentTemplates () {
      try {
        this.isFetching = true
        const { data } = await this.$axios.get('/document_templates', { params: this.params })
        this.documents = data.results.map((result) => { 
          return {
            ...this.sanitizeResult(result)
          }
        })
        this.totalCount = data.count
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isFetching = false
      }
    },
    sanitizeResult (data) {
      let result = { ...data }
      result.status = this.sanitizeStatus(data.status)
      return result
    },
    isMedicalDocumentCategory (category) {
      return category === 'medical_document'
    },
    getCategory (category) {
      const newName = category.replace(/_/g, " ")
      return this.$options.filters.capitalize(newName)
    },
    getTabCategory () {
      switch (this.templateTab) {
        case 0:
          return null

        case 1:
          return 'medical_certificate'

        case 2:
          return 'prescription_letter'

        case 3:
          return 'medical_document'

        case 4:
          return 'invoice,receipt'
      
        default:
          return null
      }
    },
    sanitizeStatus (status) {
      return status === 'active'
    },
    async updateStatus (item, status) {
      this.isFetching = true
      const statusName = status ? 'active' : 'archived'
      try {
        await this.$axios.patch(`/document_templates/${item.id}`, { status: statusName })
        this.showMessage(['success', this.$t('success_message.update_successful')])
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isFetching = false
      }
    },
    async onDelete () {
      try {
        this.isDeleting = true
        await this.$axios.delete(`/document_templates/${this.selectedDocument.id}`)
        const index = this.documents.findIndex(document => document.id === this.selectedDocument.id)
        if (index >= 0) {
          this.documents.splice(index, 1)
        }
        this.selectedDocument = null
        this.showMessage(['success', this.$t('success_message.delete_successful')])
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isDeleting = false
      }
    }
  },
}
</script>

<style lang="scss" scoped>
</style>